<template>
  <div>
    <v-divider />
    <v-row class="d-flex justify-sm-end">
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="primary"
          outlined
          :to="`/manage/forms/${moderatedOperation.object_type}/${moderatedOperation.form_name}/${moderatedOperation.id}`"
          >{{ $t("button.see.originalForm") }}</v-btn
        >
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-btn
          color="purple"
          outlined
          v-if="moderatedOperation.object_id"
          :to="`/manage/edit/researchers/edit/${moderatedOperation.object_id}`"
          >{{ $t("button.see.editObject") }}</v-btn
        >
      </v-col>
      <v-spacer />
      <v-col cols="6" sm="3" md="2" class="d-flex justify-center">
        <FinishFormSwitch :item="moderatedOperation" />
      </v-col>
      <v-col cols="6" sm="3" md="3" lg="2">
        <ProcessingCommentDialog :moderated-operation="moderatedOperation" />
      </v-col>
    </v-row>
    <v-card class="pa-2" min-height="200">
      <v-overlay
        absolute
        :opacity="0.1"
        :value="
          !(
            moderatedOperation.data !== undefined &&
            namePersons.length > 0 &&
            categories.length > 0  &&
            workplaces.length > 0
          )
        "
      >
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <AssignListRelationField
        @update-modOp-data="updateModOpData"
        :state="moderatedOperation.state"
        field="incharge"
        :data-mod-op="moderatedOperation.data"
        v-if="moderatedOperation.data !== undefined && namePersons.length > 0"
        :items-fromdb="namePersons"
        items-fromdb-text="name"
        :original_items="moderatedOperation.data.user.person.incharge"
      />
      <AssignSimpleRelationField
        @update-modOp-data="updateModOpData"
        :state="moderatedOperation.state"
        field="category"
        :data-mod-op="moderatedOperation.data"
        :items-fromdb="categories"
        v-if="moderatedOperation.data !== undefined && categories.length > 0"
        items-fromdb-text="internal_name"
      />
      <AssignLaboratoryRelationField
        @update-modOp-data="updateModOpData"
        :state="moderatedOperation.state"
        :data-mod-op="moderatedOperation.data"
        :workplace-options="workplaces"
        v-if="
          moderatedOperation.data !== undefined &&
            moderatedOperation.data.user.person.workplace !== undefined &&
            workplaces.length > 0
        "
      />
    </v-card>
    <v-divider />
    <ProcessFormActions :item="moderatedOperation" @item-processed="handleItemProcessed" />
  </div>
</template>

<script>
import ProcessFormActions from "../../action_buttons/ProcessFormActions";
import AssignSimpleRelationField from "../../reusables/AssignSimpleRelationField";
import AssignListRelationField from "../../reusables/AssignInChargeInvestigators";
import ProcessingCommentDialog from "../../reusables/ProcessingCommentDialog";
import AssignLaboratoryRelationField from "../../reusables/AssignLaboratoryRelationField";
import axios from "axios";
import FinishFormSwitch from "../../reusables/FinishFormSwitch";
import investigator_model from "../../../mixins/model_utils/investigator_model";
import publication_model from "../../../mixins/model_utils/publication_model";
export default {
  name: "ProcessInvestigator",
  mixins: [investigator_model, publication_model],
  components: {
    FinishFormSwitch,
    ProcessFormActions,
    AssignSimpleRelationField,
    AssignListRelationField,
    ProcessingCommentDialog,
    AssignLaboratoryRelationField
  },

  data: () => ({
    moderatedOperation: {}
  }),

  created() {
    this.getNamePersons();
    this.getCategories();
    this.getWorkplaces();
    this.getData();
  },
  methods: {
    handleItemProcessed(item){
      this.moderatedOperation.state = item.state;
      this.moderatedOperation.object_id = item.object_id;
    },
    
    getData() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/investigator/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.moderatedOperation = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateModOpData(data) {
      this.moderatedOperation.data = data;
    }
  }
};
</script>

<style scoped></style>
